// Universal referral tracking across ValutaGenio sub-domains via cookie.
// Cookie name: vg_ref · domain: .valutagenio.com · 30 days · SameSite=Lax · Secure.

const COOKIE_NAME = "vg_ref";
const MAX_AGE_SEC = 60 * 60 * 24 * 30;

function _isValutaGenioHost() {
  const host = (typeof window !== "undefined" && window.location.hostname) || "";
  return host === "valutagenio.com" || host.endsWith(".valutagenio.com");
}

function _writeCookie(value) {
  if (typeof document === "undefined") return;
  const parts = [
    `${COOKIE_NAME}=${encodeURIComponent(value)}`,
    "Path=/",
    `Max-Age=${MAX_AGE_SEC}`,
    "SameSite=Lax",
  ];
  if (_isValutaGenioHost()) parts.push("Domain=.valutagenio.com");
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    parts.push("Secure");
  }
  document.cookie = parts.join("; ");
}

export function readRefCookie() {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

// Sync cookie from current URL ?ref (if any). Returns the effective ref (URL > cookie > null).
export function syncRefFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const urlRef = (params.get("ref") || "").trim();
    if (urlRef) {
      _writeCookie(urlRef);
      return urlRef;
    }
  } catch (e) {
    // ignore
  }
  return readRefCookie();
}

// Resolve effective ref: URL ?ref wins, otherwise cookie, otherwise null.
export function getEffectiveRef() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const urlRef = (params.get("ref") || "").trim();
    if (urlRef) return urlRef;
  } catch (e) {
    // ignore
  }
  return readRefCookie();
}
